import React, { useState, useEffect} from 'react';
import 'antd/dist/antd.css';
import './index.scss';
import { Table, Form, Typography,  Collapse, Tooltip,  Radio, Space } from 'antd';
import { FallOutlined, RiseOutlined, PlusCircleOutlined, CaretRightOutlined, DeleteFilled} from "@ant-design/icons";

import telehealth_icon from '../../assets/telemedicine.png';
import patient_at_home_icon from '../../assets/home-health.png';
import hospital_icon from '../../assets/traditionalSite.png';
import mobile_health_icon from '../../assets/esource.png';
import pharmacy_icon from '../../assets/local-clinic.png';
import local_lab_icon from '../../assets/local-Lab.png';
import ip_direct_icon from '../../assets/ipDirectShipment.png';
import e_consent_icon from '../../assets/econsent.png';

import * as createActions from "../../actions/createTrial.js";
import {withRouter } from 'react-router';
import { connect } from "react-redux";
import EndpointDetails from "../EndpointDetails";
import { roundToTwoDecimals,toSentenceCase } from '../../utils/utils';

const { Panel } = Collapse;

const modality_options_dict ={
  "eSource & Wearables": {
    "icon": mobile_health_icon,
    "color": '#FFB600'
  },
  "Telemedicine": {
    "icon": telehealth_icon,
    "color": '#3DD5B0'
  },
  "Home Health": {
    "icon": patient_at_home_icon,
    "color": '#295477'
  },
  "Local Lab & Sample Collection": {
    "icon": local_lab_icon,
    "color": '#657DFF'
  },
  "Local Clinic": {
    "icon": pharmacy_icon,
    "color": '#E72B33'
  },
  "IP Direct Shipment": {
    "icon": ip_direct_icon,
    "color": '#00C6F7'
  },
  "eConsent": {
    "icon": e_consent_icon,
    "color": '#299D8F'
  },
  "Traditional Site": {
    "icon": hospital_icon,
    "color":'#D93954'
  },
  "": {
    "icon":'',
    "color":'white'
  }
}

const initialEndpoint = {
  "endpoint_std_term": "",
  "endpoint_category": "",
  "primary_frequency": null,
  "secondary_frequency": null,
  "endpoint_id": null,
  "cost": null,
  "endpoint_type": 'Primary',
  "modality": [],
  "usage_data" : [],
  "hist_usage_data" : [],
  "measure_timepoints":[],
  "hist_measure_timepoints":[],
  "total_trial" : null,
  "added": false,
  'endpoint_context': "", 
  'user_duration':[],   
  'selected_modality': '',
  "details": [],
}

const getModalityOptions = (modalityOpts) =>{ 
  let finalModalityOptions = []
  if(modalityOpts != null && modalityOpts != undefined){
      modalityOpts.forEach((modality) => {
          if(modality.name in modality_options_dict){
              finalModalityOptions.push({
                  key: modality.key,
                  name:  modality.name,
                  icon: modality_options_dict[modality.name].icon,
                  color: modality_options_dict[modality.name].color
            })
          }else{
            finalModalityOptions.push({
                  key: modality.key,
                  name:  modality.name,
                  icon: '',
                  color: 'white'
            })
          }
      });
      finalModalityOptions.push({
          key:"",
          name:  "",
          icon:'',
          color:'white'
      })
      return finalModalityOptions;
  }else{
      return []
  }
}


const EditEndpointsTable = (props) => {
    const { panelHeader } = props
    const [form] = Form.useForm();
    const [activeKey, setActiveKey] = useState([])
    const [data, setData] = useState([]);
    const [addActivityModal, setAddActivityModal] = useState(false);
    const [selectedActivity, setSelectedActivity] = useState(initialEndpoint)
    const collapsedId = JSON.parse(localStorage.getItem('ts_id'));


    const modalityOptions = getModalityOptions([
      {"key":1,"name":"eSource & Wearables","color":"#FFBF00"},
      {"key":2,"name":"Telemedicine","color":"#75C716"},
      {"key":3,"name":"Home Health","color":"#C9DF00"},
      {"key":4,"name":"Local Lab & Sample Collection","color":"#6A86FA"},
      {"key":5,"name":"Local Clinic", "color":"#FF025F"},
      {"key":6,"name":"IP Direct Shipment", "color":"#83B1FA"},
      {"key":7,"name":"eConsent","color":"#00A760"},
      {"key":8,"name":"Traditional Site","color":"#CB0047"}])   
    useEffect(() => {
      const trialData =  props.newEndpoint.endpointAdded?.filter( item => item.endpoint_type === panelHeader)  
      const sortedData = trialData?.sort((a, b) => a.endpoint_std_term < b.endpoint_std_term ? -1 : 1);
      setData(sortedData);
    }, [props.newEndpoint.endpointAdded]);

    useEffect(() => {
     const storedValues = JSON.parse(sessionStorage.getItem(`endpoints_${collapsedId}`));
      if (!storedValues) {
        setActiveKey(['1','2','3']);
        sessionStorage.setItem(`endpoints_${collapsedId}`, JSON.stringify(['1','2','3']));
      } 
      else{
        setActiveKey(storedValues);
      }
    },[]);


    function getMeasureTimePoints(array, count) {
      if(!array) return; 
      let string = ''
      if (array.length > count) {
            string = array.slice(0, count).join(',') + '...';
      } else {
            string = array.join(',');
      }
        return `${string} Weeks`
    }

    const handleDetailUpdate = (value) => { 
      handleToggleActivity(value, 'update')
      setAddActivityModal(false);
      setSelectedActivity(initialEndpoint);
    }

    const updateActivity = (e, record, idx) => {  
      setAddActivityModal(true)
      setSelectedActivity({...record, idx: idx})
    }

    const removeActivity = (e, record, idx) => {
      handleToggleActivity(record, 'remove')
    }

    const handleToggleActivity = ( evt, flag) => { 
      const endpointAddedData = [...props.newEndpoint.endpointAdded]
     
      let index = endpointAddedData.findIndex((d) =>  evt['endpoint_std_term'] === d['endpoint_std_term'] && evt['endpoint_id'] === d['endpoint_id'] && evt['trial_endpoint_id'] === d['trial_endpoint_id']);
      const newData = [...endpointAddedData]
      if(flag === 'remove'){
        newData.splice(index, 1)
      } else {
        newData[index] = evt; 
      }
      props.updateEndpoints({ endpointAdded: newData })
    }

    const onChange = (e, evt) => {
      const endpoints = [...props.newEndpoint.endpointAdded]
      const index = endpoints.findIndex(item => item['endpoint_std_term'] === evt['endpoint_std_term']);
      if(index !== -1) {
        endpoints.map((item, index) => {
          if(item['endpoint_std_term'] === evt['endpoint_std_term']) {
            item.selected_modality = e.target.value !== ''? e.target.value : null; 
          }
          return item
        })
        props.updateEndpoints({ endpointAdded: endpoints })
      }

    };

    const ModalityList = (props) => {
      const {  evt } = props
      return (
        <Radio.Group onChange={(e) => onChange(e, evt)} value={evt.selected_modality}>
          <Space direction="vertical">
            {
              modalityOptions.map( (m,idx)=>{
                return (
                  <div className="modality-item" key={idx}>
                  <Radio
                  value={m.key}
                  disabled={evt?.modality&&evt.modality[idx]==0?true:false
                  }>
                
                <img src={m.icon} alt="" style= {{
                  backgroundColor: m.color, 
                  borderRadius: '50%',
                  marginRight: m.name !== "Clear" ? '2px' : '0px',
                }} /> 
                {m.name.length > 0 ? toSentenceCase(m.name ): "Clear"}
                  </Radio>
                </div>
                )
            })
            }
          </Space>
        </Radio.Group>
      );
    }

    const clickHandler = (evt, record) => {

    }
    
    const checkIsTrending = (status) => {
      let content = (<></>);
      if(status && status?.toLowerCase() === 'up') {
        content = (<RiseOutlined style={{color: '#88C540'}} />)
      } else if(status && status?.toLowerCase() === 'down') {
        content = (<FallOutlined style={{color: '#CC0537'}} />)
      }
      return content;
    }

    const columns = [
        {
          title: "Standard Activity",
          dataIndex: "Standard Activity",
          width: '20.85%', 
          // align: 'center',
          className: 'left-column',
          render: (_, record) => {
            return (<>
             <span style={{paddingRight: '3px', display: 'inline-block', verticalAlign: 'top'}}>{checkIsTrending(record['trend'])}</span>
             <Typography.Link >
              <Tooltip
                  title={record['endpoint_std_term']} 
                >
                  <span className='endpoint-ellipsis' style={{maxWidth: 200}}>
                    {record['endpoint_std_term']}
                  </span>
                </Tooltip> 
             </Typography.Link>
            </>)
          }
        },
        {
          title: "Context",
          dataIndex: "Context",
          width: '20.85%', 
          // align: 'center',
          className: 'left-column',
          render: (_, record) => {
            return (<Typography.Link >
             <Tooltip
                title={record['endpoint_context']} 
              >
                <span className='endpoint-ellipsis' style={{maxWidth: 170, paddingLeft: '0px'}}>
                  {record['endpoint_context']}
                </span>
              </Tooltip> 
            </Typography.Link>)
          }
        },
        {
          title: "modality",
          dataIndex: "modality",  
          // align: 'left',
          // className: 'centered-column',
          width: '8.3%', 
          render: (_, record) => {
            const targetItem = modalityOptions?.find(m => m.key === record.selected_modality)
            return (
              <div style={{ display: 'flex', alignItems: 'center' }}>
              <Tooltip
                title={
                  <ModalityList
                    modality={record.modality}
                    evt={record}
                  />
                }
                color="#ffffff" 
                mouseEnterDelay={0.2}
              >
              {Boolean(record.selected_modality) ? 
                            <img src={targetItem.icon}
                              alt=''
                             onClick={(e) => clickHandler(e, record)}
                             style={{
                              backgroundColor: targetItem.color, 
                              borderRadius: '50%',
                            }}
                             />
                              : 
                              <PlusCircleOutlined onClick={(e) => clickHandler(e,record)}/>
                            }
              </Tooltip>
              </div>)
          }
        },{
          title: 'primary_frequency',
          dataIndex: 'primary_frequency',
          width: '12.5%',
          render: (_, record) => {
            return (<>
                {roundToTwoDecimals(Math.round(record['primary_frequency'] * 10000) / 100 )+ "%"}
            </>)
          }
        }, {
          title: 'secondary_frequency',
          dataIndex: 'secondary_frequency',
          width: '12.5%',
          editable: false,
          render: (_, record) => {
            return (<>
                {roundToTwoDecimals(Math.round(record['secondary_frequency'] * 10000) / 100) + "%"}
            </>)
          }
        }, {
            title: 'user_duration',
            dataIndex: 'user_duration',
            width: '16.7%',
            editable: false,
            render: (_, record) => {
              return (
              <Typography.Link >
              <Tooltip title={getMeasureTimePoints(record['user_duration'], record['user_duration']?.length)}>
              <span className='endpoint-ellipsis' style={{maxWidth: 170, paddingLeft: '0px'}}>
                  {record['user_duration']?.length > 0 ? getMeasureTimePoints(record['user_duration'], 5) : ''}
              </span>
              </Tooltip>
              </Typography.Link>
              )
            }
          }, {
          title: 'operation',
          width: '8.3%',
          dataIndex: 'operation',
          render: (_, record, index) => {
            return (
                <span>
                  <span style={{color:'#CA4A04',marginRight:8,cursor:'pointer'}}  //onClick={() => handleEdit(record)}
                  onClick={(e) => updateActivity(e, record, index)} 
                  >Details</span>
                  <DeleteFilled 
                   onClick={(e) => removeActivity(e, record, index)} 
                   style={{color:'#BABABA',verticalAlign:'text-bottom'}} //onClick={() => handleDelete(record)}
                  />
                </span>
              )
          }
        }
    ];

    function callback(key) {
      let activePanels = JSON.parse(sessionStorage.getItem(`endpoints_${collapsedId}`)) || [];
      const tableIndexString = props.tableIndex.toString();
    
      if (key.includes(tableIndexString)){
        if (!activePanels.includes(tableIndexString)) {
          activePanels.push(tableIndexString);
        }
      } else {
        const index = activePanels.indexOf(tableIndexString);
        if(index > -1) {
          activePanels.splice(index, 1);
        }
      }
      setActiveKey(activePanels);
      sessionStorage.setItem(`endpoints_${collapsedId}`, JSON.stringify(activePanels));
    }

    const panelHeaderSection = (header, count) => {
        return (
            <div className={`${props.collapsible  ? '' : 'none-click'} trial-panelHeader`}>
              <div className="header-section">
                <span style={{paddingLeft: '20px'}}>{header}({count === 0 ? 0 : count})</span>
              </div>
            </div>
        );
    };

    const mergedColumns = columns.map((col) => {
      if(col.title === "Eligibility Criteria" ) {
        col.editable = true
      } else if (col.title === "Eligibility Criteria"){
        col.editable = false
      }
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: (record) => ({
          record,
          inputType: 'text',
          dataIndex: col.dataIndex,
          title: col.title, 
        })
      };
    });

    return (
      <>
      <Form form={form} component={false}>
        <Collapse activeKey={activeKey} onChange={callback} expandIconPosition="left"
          expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}>
          <Panel header={panelHeaderSection(props.panelHeader, props.collapsible ? 0 : data.length)}
            key={props.tableIndex} forceRender={false} >
            <Table
             className='new-endpoint-table'
             pagination={false} showHeader={false} rowKey={record => record.Key}
              locale={{ emptyText: 'No Data' }}
              dataSource={data} columns={mergedColumns} rowClassName="editable-row"
              expandedRowKeys={data.map(item => item.Key)} />
          </Panel>
        </Collapse>
      </Form>
      <EndpointDetails
          whetherModal = {addActivityModal}
          selectedData = {selectedActivity}
          handleDetailUpdate = {handleDetailUpdate}
          isBuilderTable={true}
        />  
      </>
    );

}

const mapDispatchToProps = (dispatch) => ({
  createTrial: (val) => dispatch(createActions.createTrial(val)),
  updateEndpoints: (val) => dispatch(createActions.updateEndpoints(val))
});

const mapStateToProps = (state) => ({
newTrial: state.trialReducer,
newEndpoint: state.endpointReducer,
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EditEndpointsTable));